import React, { useEffect } from "react";
import { Autocomplete, Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Grid, Paper, styled, TextField } from "@mui/material";
import axios from "axios";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import ConfirmDialog, { confirmDialog } from "../ConfirmDialog";
import { ICrew } from "../../interfaces/ICrew";
import DialogContentText from '@mui/material/DialogContentText';
import { IWeather } from "../../interfaces/Growing/IWeather";
import { useAppSelector } from "../../hooks";

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#010101' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    border: 0,
    borderRadius: 0,
    boxShadow: "none",
}));


type Props = {
    open: boolean,
    handleClose: () => void
}

export default function WeatherDialog(props: Props) {

    const { register, handleSubmit, control, formState: { errors } } = useForm<IWeather>();
    var appUser = useAppSelector((state) => state.application.loggedInUser);
    const [open, setOpen] = React.useState(false);
    const [crews, setCrews] = React.useState<ICrew[]>([]);
    const [acids, setAcids] = React.useState<IAcid[]>([]);
    const [fertilizers, setFertilizers] = React.useState<IFertilizer[]>([]);
    const [chemicals, setChemicals] = React.useState<IChemical[]>([]);

    interface IAcid {
        id: number,
        name: string
    }

    interface IFertilizer {
        id: number,
        name: string
    }

    interface IChemical {
        id: number,
        name: string
    }



    const onSubmit: SubmitHandler<IWeather> = data => {
        console.log(data);
        let massagedData: IWeather = {
            id: data.id != undefined ? data.id : 0,
            userId: appUser! != undefined ? appUser?.id : 0,
            temperature: data.temperature,
            humidity: data.humidity,
            notes: data.notes,
            dateRecorded: new Date(),
            updatedAt: new Date(),
            createdAt: new Date()

        }
        console.log("MASSAGED DATA", massagedData);
        axios.post(`${process.env.REACT_APP_ENDPOINT}/api/Weathers`, massagedData).then((data) => {
            if (data.status === 200) {
                props.handleClose();
            };
        });
    };

    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_ENDPOINT}/api/Crews`)
            .then(res => {
                setCrews(res.data);
            })

        var exampleAcid: IAcid = {
            id: 1,
            name: "Acid 1"
        }

        setAcids([{ id: 1, name: "Acid 1" }, { id: 2, name: "Acid 2" }, { id: 3, name: "Acid 3" }]);
        setFertilizers([{ id: 1, name: "Fertilizer 1" }, { id: 2, name: "Fertilizer 2" }, { id: 3, name: "Fertilizer 3" }]);
        setChemicals([{ id: 1, name: "Chemical 1" }, { id: 2, name: "Chemical 2" }, { id: 3, name: "Chemical 3" }]);
    }, [])

    const pipes = [
        { id: 1, label: 'Red Pipe' },
        { id: 2, label: 'Blue Pipe' },
        { id: 3, label: 'Plain Pipe' },
    ];



    return (
        <Dialog open={props.open} onClose={props.handleClose} maxWidth='md' fullWidth>
            <DialogTitle>Add Weather Log</DialogTitle>
            <Box component="form">
                <DialogContent>
                    <Item>
                        <TextField
                            required
                            variant="filled"
                            fullWidth
                            id="temperature"
                            label="Temperature °F"
                            {...register('temperature')}
                /* {...register("Name")} */ />
                    </Item>
                    <Item>
                        <TextField
                            required
                            variant="filled"
                            fullWidth
                            id="humidity"
                            label="Humidity"
                            {...register('humidity')}
                /* {...register("Name")} */ />
                    </Item>
                    <Item>
                        <TextField
                            required
                            variant="filled"
                            fullWidth
                            id="weathernotes"
                            label="Notes"
                            {...register('notes')}
                            />
                    </Item>
                </DialogContent>
                <DialogActions>
                    <Button size="large" variant="outlined" onClick={props.handleClose}>Cancel</Button>
                    <Button size="large" variant="contained" color="success" onClick={() => confirmDialog("Are you sure you want to add this weather log?", handleSubmit(onSubmit))}>Add Log</Button>
                </DialogActions>
                <ConfirmDialog />
            </Box>
        </Dialog>
    )
}